import angular from 'angular';
import BaseComponent from '../base/component';
import { withAngularComponent } from '../base/decorators';
import template from './template.html';
import './botAvatar';
import './style.scss';

@withAngularComponent({
    name: 'botTipsComponent',
    template,
    bindings: {
        botType: '@',
        botTipText: '@',
        actionHandler: '&',
    },
    controllerAs: 'ctrl',
})
export class BotTips extends BaseComponent {

}

angular.module('TALENYA-FE').directive('renderBotTip', $compile => ({
    link(scope, element) {
        const content = $compile(scope.ctrl.botTipText)(scope);
        element.append(content);
    },
}));
